import React, { Component } from "react";
import { Row, Col } from "shards-react";

import "./css/dashbordCard.css";

import Cookie from "js-cookie";
const axios = require("axios").default;
const URL = require("../../ApiUrl");

export default class dashbordCard extends Component {
  constructor(props) {
    super(props);
    this.getBasicSts = this.getBasicSts.bind(this);
    this.BasicCards = this.BasicCards.bind(this);

    this.state = {
      isLoaded: false,
      basic_status: {
        male: 0,
        female: 0,
        patient_count: 0,
        acs: 0
      }
    };
  }

  async getBasicSts() {
    const token = Cookie.get("jwtToken") ? Cookie.get("jwtToken") : null;

    let response2 = await axios({
      method: "get",
      url: `${URL.BASE_URL}/forms/basic`,

      headers: { Authorization: `Bearer ${token}` }
    });
    if (response2.data.statusCode === 200) {
      this.setState({ basic_status: response2.data.data });
    }

    console.log(response2.data.data);
    //console.log(response.data.data);
  }

  componentDidMount() {
    this.getBasicSts();
  }

  BasicCards() {
    return (
      <div>
        <Row>
          <Col lg="3" md="6">
            <div className="cards card1">
              <div className="subtitle">Total Patients</div>
              <div className="title">
                {this.state.basic_status.patient_count}
              </div>
            </div>
          </Col>

          <Col lg="3" md="6">
            <div className="cards card1">
              <div className="subtitle">Female Patients</div>
              <div className="title">{this.state.basic_status.female}</div>
            </div>
          </Col>

          <Col lg="3" md="6">
            <div className="cards card1">
              <div className="subtitle">Male Patients</div>
              <div className="title">{this.state.basic_status.male}</div>
            </div>
          </Col>

          <Col lg="3" md="6">
            <div className="cards card1">
              <div className="subtitle">ACS </div>
              <div className="title">{this.state.basic_status.acs}</div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    return (
      <>
        <this.BasicCards />
      </>
    );
  }
}
